import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  subscriptions: [],
  sites: [],
});

const { Types, Creators } = createActions({
  updateSitesQueues: ['sites'],
  updateSubscriptions: ['subscriptions'],
  clearSubscriptions: null,
});

export const updateSitesQueues = (state, { sites }) => {
  return state.merge({ sites });
};
export const updateSubscriptions = (state, { subscriptions }) => {
  return state.merge({ subscriptions });
};
export const clearSubscriptions = (state) => {
  return state.merge({ subscriptions: [] });
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_SITES_QUEUES]: updateSitesQueues,
  [Types.UPDATE_SUBSCRIPTIONS]: updateSubscriptions,
  [Types.CLEAR_SUBSCRIPTIONS]: clearSubscriptions,
});

export const WebSocketTypes = Types;
export default Creators;
